import React from 'react';

import d2dLogo from '@assets/img/icons/d2d-black.png';
import { ClassMap, makeMuiStyles } from '@styles';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  printableContainer: {
    padding: '3rem 3rem',
    backgroundColor: theme.palette.background.paper,
  },
  printableInner: {
    ...common.flexColumn,
    maxWidth: '40rem',
    padding: '1rem 2rem',
    margin: '0 auto',
  },
  printableHeader: {
    marginBottom: '1rem',
  },
}));

export interface ContainerProps {
  classes?: ClassMap<'container' | 'inner'>;
}

export const PrintableContainer: React.FC<React.PropsWithChildren<ContainerProps>> = (props) => {
  const classes = useStyles();

  const { classes: customClasses = {}, children } = props;

  return (
    <div className={clsx(classes.printableContainer, customClasses.container)}>
      <div className={clsx(classes.printableInner, customClasses.inner)}>
        <div className={clsx(classes.printableHeader)}>
          <img alt="D2D Logo" src={d2dLogo} height={23} width={100} />
        </div>
        {children}
      </div>
    </div>
  );
};
